import { render } from "./chathistoryitem.vue?vue&type=template&id=4b053736&scoped=true"
import script from "./chathistoryitem.vue?vue&type=script&lang=js"
export * from "./chathistoryitem.vue?vue&type=script&lang=js"

import "./chathistoryitem.vue?vue&type=style&index=0&id=4b053736&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b053736"]])

export default __exports__